module.exports = __webpack_public_path__ + "static/media/sub-1w.a4bdc953.svg";